import { render, staticRenderFns } from "./academy-card.vue?vue&type=template&id=ecfa4d78&scoped=true&"
import script from "./academy-card.vue?vue&type=script&lang=js&"
export * from "./academy-card.vue?vue&type=script&lang=js&"
import style0 from "./academy-card.vue?vue&type=style&index=0&id=ecfa4d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa4d78",
  null
  
)

export default component.exports